module.exports = __webpack_public_path__ + "img/01-1市场渗透率分析.8fdebde4.png";